"use client";

import { FcGoogle } from "react-icons/fc";
import { signIn, signOut } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import toast from "react-hot-toast";

export const GoogleSignInButton = () => {
  const searchParams = useSearchParams();
  const nextPath = searchParams?.get("next") || "/"; // fallback vers "/"

  const handleGoogleLogin = async () => {
    try {
      // Supprimer la session actuelle
      await signOut({ redirect: false });

      // Rediriger vers Google et revenir sur le callback
      await signIn("google", {
        redirect: true,
        prompt: "select_account",
        callbackUrl: nextPath, // rediriger vers nextPath si présent
      });
    } catch (err: any) {
      console.error(err);
      toast.error(`Erreur : ${err.message || err}`);
    }
  };

  return (
    <button
      type="button"
      onClick={handleGoogleLogin}
      className="flex items-center justify-center w-full gap-2 p-3 mt-0 border border-gray-300 rounded hover:bg-gray-100 transition cursor-pointer"
    >
      <FcGoogle className="text-xl" />
      <span className="capitalize">google</span>
    </button>
  );
};
